import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import PlatformStatusForm from './form'
import VendorPicker from '../../components/vendorPicker'
import Table from '../../components/MUITable'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'

import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import RefreshIcon from '@mui/icons-material/Refresh'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import IndianaScroller from 'react-indiana-drag-scroll'

const PlatformStatusesToolbar = (props) => {
  const { selected, add, edit, remove, disabled } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected._id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)


  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Estados de Plataforma
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title={"Editar Estado de Plataforma "}>
            <IconButton onClick={edit}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
      <Tooltip title={disabled?"Seleccione canal de venta":"Añadir Estado de Plataforma"}>
        <span>
          <IconButton disabled={disabled} onClick={add}>
            <AddIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Toolbar>
  )
}

const PlatformStatuses = () => {
  const [selected, setSelected] = React.useState([])
  const app = React.useContext(AppContext)  
  const { current } = app
  const { platformstatuses, detail, remove } = app.platformstatuses
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }

  React.useEffect(() => {
    if(selected.length == 1)
      detail(platformstatuses[selected[0]-1])
    else
      detail(null)
  }, [selected])

  return (
    <IndianaScroller>
    <Stack>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%">
        <VendorPicker/>
      </Box>
      <PlatformStatusesToolbar selected={current} add={openD} edit={openD} remove={remove} disabled={!app.vendor}/>
      <Table
        model={selected}
        setmodel={setSelected}
        data={platformstatuses}
        getRowId={(row) => row._id}
        columns={[
          { title: 'Tipo', field: 'type' },
          { title: 'Nombre', field: 'name' },
          { title: 'Canal', field: 'vendor' }
        ]}
        options={{
          selection: true,
          pageSizes:[5, 10,25,50,100,250,500]
        }}
        sx={{
          '& .MuiDataGrid-cellContent': {
          overflow: 'scroll',
          textOverflow: 'unset',
          }
            }}
      />
      <PlatformStatusForm open={open} model={current} close={() => setOpen(false)}/>
    </Stack>
    </IndianaScroller>
  )
}
export default PlatformStatuses